import React from 'react';
import {
  Container,
  Grid,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import HelpView from './HelpView';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    padding: 0,
    margin: 15
  }
}));

const Help = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Help"
    >
      <Container maxWidth="lg">
        <Grid
          display="flex"
          justifyContent="flex-start"
          container
          spacing={3}
        >
          <Grid
            item
            lg={12}
            md={12}
            xs={12}
          >
            <HelpView />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
};

export default Help;
